import React from "react";
import { Spinner } from "react-bootstrap";

export const getInitiales = (nom = "", prenom = "") => {
  const n = (nom || "").trim().charAt(0).toUpperCase();
  const p = (prenom || "").trim().charAt(0).toUpperCase();
  return `${p}${n}` || "?";
};

export const RsKpiCard = ({ label, value, variant }) => (
  <div className={`rs-kpi-card rs-kpi-${variant}`}>
    <div className="rs-kpi-label">{label}</div>
    <div className="rs-kpi-value">
      {Number(value || 0).toLocaleString("fr-FR")}{" "}
      <span className="rs-kpi-unit">GNF</span>
    </div>
  </div>
);

export const RsKpiGrid = ({ children, className = "" }) => (
  <div className={`rs-kpi-grid mb-4 ${className}`.trim()}>{children}</div>
);

export const RsEmptyHint = ({ title, children }) => (
  <div className="salaires-empty-hint">
    <strong>{title}</strong>
    {typeof children === "string" ? <p className="mb-0 mt-2">{children}</p> : children}
  </div>
);

export const RsLoadingBlock = ({ label = "Chargement…" }) => (
  <div className="rs-loading-block">
    <Spinner animation="border" size="lg" />
    <p className="mt-3 mb-0">{label}</p>
  </div>
);

export const RsSectionCard = ({ title, badge, headerExtra, children, bodyClassName = "" }) => (
  <div className="salaires-section-card">
    <div className="section-header">
      <h6>{title}</h6>
      <div className="d-flex align-items-center gap-2">
        {badge}
        {headerExtra}
      </div>
    </div>
    <div className={`section-body ${bodyClassName}`.trim()}>{children}</div>
  </div>
);

export const RsEmployeePreview = ({ nom, prenom, poste, meta }) => (
  <div className="salaires-employee-block rs-employee-preview-compact">
    <div className="rs-employee-header mb-0">
      <div className="rs-employee-avatar" aria-hidden="true">
        {getInitiales(nom, prenom)}
      </div>
      <div className="rs-employee-info">
        <h5>{prenom} {nom}</h5>
        {poste && <p className="rs-employee-poste">{poste}</p>}
        {meta && <div className="rs-employee-meta">{meta}</div>}
      </div>
    </div>
  </div>
);
